import Link from "next/link";
import getConfig from "next/config";
import classNames from "classnames";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const NoRatingsDataPlaceholder = ({ productUrl, onClick }) => (
  <span className="flex items-center sm:w-auto">
    <Link href={`${productUrl}#reviews`}>
      <a
        onClick={onClick}
        href="#reviews"
        className={classNames(
          "leading-none text-red-brand md:text-base text-sm",
          {
            "text-[#1D4ED8]": websiteName !== "bricostore",
            "text-orange": websiteName === "bricostore",
          }
        )}
      >
        Fii primul care evalueaza acest produs
      </a>
    </Link>
  </span>
);

export default NoRatingsDataPlaceholder;
